import { PlanoFixo } from '@/service/api'
import ContentGuide from 'global/guides/ContentGuide'
import { usePlanosContext } from 'pages/Planos.context'
import React, { useMemo, useState } from 'react'
import { PlanosCard } from './components/PlanosCard'

type TipoPlanos = 'mensal' | 'trimestral' | 'anual'

type Data = {
    mensal: PlanoFixo[]
    anual: PlanoFixo[]
    trimestral: PlanoFixo[]
}

const STATUS_ATIVOS_PENDENTES = ['active', 'waitingPayment']

export const Planos: React.FC = () => {
    const { planos, assinatura, PlanoDiferenciado } = usePlanosContext()
    const [value, setValue] = useState<TipoPlanos>('mensal')

    const { anual, mensal, trimestral } = useMemo<Data>(() => {
        if (planos) {
            return {
                anual: planos.filter(plano => plano.periodicity === 'yearly'),
                mensal: planos.filter(plano => plano.periodicity === 'monthly'),
                trimestral: planos.filter(
                    plano => plano.periodicity === 'quarterly',
                ),
            }
        }

        return { mensal: [], anual: [], trimestral: [] }
    }, [planos])

    const handleChange = (newValue: string) => {
        setValue(newValue as TipoPlanos)
    }

    if (PlanoDiferenciado)
        return (
            <ContentGuide>
                <PlanosCard
                    planos={[
                        {
                            id: 0,
                            limiteFuncionarios: 0,
                            periodicity: PlanoDiferenciado.periodicidade,
                            price: PlanoDiferenciado.valorCentavos,
                        },
                    ]}
                    trocar={STATUS_ATIVOS_PENDENTES.includes(
                        assinatura?.status || '',
                    )}
                />
            </ContentGuide>
        )

    const trocar = STATUS_ATIVOS_PENDENTES.includes(assinatura?.status || '')

    return (
        <ContentGuide>
            <ContentGuide.Tabbed
                value={value}
                onValueChange={handleChange}
                tabs={[
                    {
                        value: 'mensal',
                        label: 'Planos mensais',
                        content: <PlanosCard planos={mensal} trocar={trocar} />,
                    },
                    {
                        value: 'trimestral',
                        label: 'Planos trimestrais',
                        content: (
                            <PlanosCard planos={trimestral} trocar={trocar} />
                        ),
                    },
                    {
                        value: 'anual',
                        label: 'Planos anuais',
                        content: <PlanosCard planos={anual} trocar={trocar} />,
                    },
                ]}
            />
        </ContentGuide>
    )
}
